import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHead, Reveal } from "@/components/Reveal";

export default function HowCapable() {
  return (
    <section id="assessment" data-testid="how-capable-section" className="relative bg-volt text-black py-24 sm:py-32 px-5 sm:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-5xl">
        <Reveal>
          <p className="text-xs sm:text-sm uppercase tracking-[0.25em] font-extrabold mb-5">
            Free 2-minute assessment
          </p>
        </Reveal>
        <Reveal delay={0.06}>
          <h2 className="font-display uppercase leading-[0.85] text-6xl sm:text-8xl lg:text-9xl">
            How capable <span className="block">are you?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 text-base sm:text-lg font-semibold max-w-xl leading-relaxed text-black/80">
            Fitness isn't only about how much you can lift — it's about what your body can DO.
            8 questions. 2 minutes. Free. Instant score.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <Link
            to="/assessment"
            data-testid="how-capable-cta"
            className="group mt-10 inline-flex items-center gap-3 bg-black text-volt uppercase tracking-[0.18em] text-xs sm:text-sm font-extrabold px-8 py-5 hover:bg-zinc-900 transition-colors"
          >
            Take the free assessment
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
          </Link>
        </Reveal>
      </div>
      <span aria-hidden="true" className="pointer-events-none select-none absolute -bottom-10 -right-6 font-display uppercase text-[38vw] leading-none text-black/5">
        360
      </span>
    </section>
  );
}
